interface LoadingSkeletonProps {
  rows?: number;
  variant?: "list" | "card" | "detail";
  className?: string;
}

export function LoadingSkeleton({
  rows = 5,
  variant = "list",
  className,
}: LoadingSkeletonProps) {
  if (variant === "card") {
    return (
      <div
        className={`rounded-2xl border border-[color:var(--border-light)] bg-[color:var(--surface)] p-4 ${className ?? ""}`}
      >
        <div className="flex flex-col gap-3">
          <div className="h-6 w-1/3 animate-pulse rounded bg-[color:var(--surface-alt)]" />
          {Array.from({ length: rows }, (_, i) => (
            <div
              key={i}
              className={`h-4 animate-pulse rounded bg-[color:var(--surface-alt)] ${
                i % 3 === 0 ? "w-full" : i % 3 === 1 ? "w-2/3" : "w-1/2"
              }`}
            />
          ))}
        </div>
      </div>
    );
  }

  if (variant === "detail") {
    return (
      <div className={`flex flex-col gap-4 ${className ?? ""}`}>
        <div className="h-8 w-1/2 animate-pulse rounded-xl bg-[color:var(--surface-alt)]" />
        <div className="flex flex-col gap-2">
          <div className="h-5 w-full animate-pulse rounded bg-[color:var(--surface-alt)]" />
          <div className="h-5 w-2/3 animate-pulse rounded bg-[color:var(--surface-alt)]" />
        </div>
        <div className="grid gap-3">
          {Array.from({ length: rows }, (_, i) => (
            <div
              key={i}
              className="h-16 animate-pulse rounded-xl bg-[color:var(--surface-alt)]"
            />
          ))}
        </div>
      </div>
    );
  }

  // Default: list variant
  return (
    <div className={`grid gap-3 ${className ?? ""}`}>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className="h-20 animate-pulse rounded-xl bg-[color:var(--surface-alt)]"
        />
      ))}
    </div>
  );
}
